export function getServiceName(key: string) {
    const names = {
        openingHours: "Heures d'ouverture",
        pickupService: 'Heures de retrait',
        deliveryService: 'Heures de livraison',
        tableReservation: 'Heures de réservation de table'
    }
    return names[key as keyof typeof names] || ''
}